import { IConfigTradeIn } from '../../types/IConfigTradeIn';

const globalConfig = {};

export function setGlobalConfig(config: IConfigTradeIn) {
    Object.keys(config).forEach((key) => {
        const descriptor = Object.getOwnPropertyDescriptor(config, key);
        // Forward getters as-is so values are read lazily. Eager evaluation breaks
        // the static rendering flow, where window.drs__SpGlobalConfig is populated
        // AFTER this module is loaded — capturing the value now would store undefined.
        if (descriptor?.get) {
            Object.defineProperty(globalConfig, key, descriptor);
        } else {
            globalConfig[key] = config[key];
        }
    });
}
export default globalConfig as IConfigTradeIn;
